var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScalePlate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290.75,
    height: 130.35,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "gradient0",
    gradientTransform: "matrix(0.24945068359375 0 0 0.24945068359375 0 -44)",
    spreadMethod: "pad",
    cy: 0,
    cx: 0,
    r: 819.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gradient1",
    gradientTransform: "matrix(0.1798095703125 0 0 0.1798095703125 0 -29.25)",
    spreadMethod: "pad",
    cy: 0,
    cx: 0,
    r: 819.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gradient2",
    gradientTransform: "matrix(0.0275726318359375 0 0 0.0275726318359375 4.8 -8)",
    spreadMethod: "pad",
    cy: 0,
    cx: 0,
    r: 819.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 132.35,
    width: 292.75,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    d: "m266.599976,10.766666q19.650024,1.450002 19.650024,3.200002q0,2.549998 -41.250015,4.349998q-41.300003,1.850002 -99.600006,1.900002l-3.699997,0q-56,-0.100002 -95.950005,-1.900002q-41.249992,-1.799999 -41.249992,-4.349998q0,-1.75 19.649994,-3.200002l21.599998,-1.2q41.25,-1.849999 99.650002,-1.8q58.300003,-0.049999 99.600006,1.8l21.599991,1.2",
    fill: "url(#gradient0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    d: "m145.399979,22.266666l0,43.999996",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 7,
    stroke: "#666666",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    d: "m266.599976,10.766666q19.650024,1.450002 19.650024,3.200002q0,2.549998 -41.250015,4.349998q-41.300003,1.850002 -99.600006,1.900002l-3.699997,0q-56,-0.100002 -95.950005,-1.900002q-41.249992,-1.799999 -41.249992,-4.349998q0,-1.75 19.649994,-3.200002l21.599998,-1.2q41.25,-1.849999 99.650002,-1.8q58.300003,-0.049999 99.600006,1.8l21.599991,1.2",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "url(#gradient1)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_5",
    d: "m161.149979,65.216667q0,-6.600002 -4.649994,-11.25q-4.650009,-4.650002 -11.25,-4.650002q-6.600006,0 -11.25,4.650002q-4.649994,4.649998 -4.649994,11.25q0,6.600006 4.649994,11.25q4.649994,4.650002 11.25,4.650002q6.599991,0 11.25,-4.650002q4.649994,-4.649994 4.649994,-11.25m11.350006,-26.100002q11.249985,11.25 11.249985,27.149998q0,15.900009 -11.249985,27.100006q-11.200012,11.25 -27.100006,11.25q-15.899994,0 -27.150002,-11.25q-11.199997,-11.199997 -11.199997,-27.100006q0,-15.899998 11.199997,-27.149998q11.250008,-11.199997 27.150002,-11.199997q15.899994,0 27.100006,11.199997",
    fillOpacity: 0.2,
    fill: "#3399ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_6",
    d: "m161.149979,65.216667q0,6.600006 -4.649994,11.25q-4.650009,4.650002 -11.25,4.650002q-6.600006,0 -11.25,-4.650002q-4.649994,-4.649994 -4.649994,-11.25q0,-6.600002 4.649994,-11.25q4.649994,-4.650002 11.25,-4.650002q6.599991,0 11.25,4.650002q4.649994,4.649998 4.649994,11.25",
    fill: "url(#gradient2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_7",
    d: "m161.149979,65.216667q0,6.600006 -4.649994,11.25q-4.650009,4.650002 -11.25,4.650002q-6.600006,0 -11.25,-4.650002q-4.649994,-4.649994 -4.649994,-11.25q0,-6.600002 4.649994,-11.25q4.649994,-4.650002 11.25,-4.650002q6.599991,0 11.25,4.650002q4.649994,4.649998 4.649994,11.25m11.350006,-26.100002q11.249985,11.25 11.249985,27.149998q0,15.900009 -11.249985,27.100006q-11.200012,11.25 -27.100006,11.25q-15.899994,0 -27.150002,-11.25q-11.199997,-11.199997 -11.199997,-27.100006q0,-15.899998 11.199997,-27.149998q11.250008,-11.199997 27.150002,-11.199997q15.899994,0 27.100006,11.199997",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.05,
    stroke: "#666666",
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "svg_13",
    y2: 736.174988,
    x2: 1261.875,
    y1: 772.174988,
    x1: 1209.875,
    fillOpacity: "null",
    strokeOpacity: "null",
    stroke: "#666666",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "svg_14",
    y2: 724.174988,
    x2: 1293.875,
    y1: 771.174988,
    x1: 1210.875,
    fillOpacity: "null",
    strokeOpacity: "null",
    stroke: "#666666",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "svg_15",
    y2: 727.174988,
    x2: 1214.875,
    y1: 724.174988,
    x1: 1293.875,
    fillOpacity: "null",
    strokeOpacity: "null",
    stroke: "#666666",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "svg_17",
    y2: 867.799583,
    x2: 1527.582657,
    y1: 731.799583,
    x1: 1231.582657,
    fillOpacity: "null",
    strokeOpacity: "null",
    stroke: "#666666",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "svg_18",
    y2: 732.799583,
    x2: 1230.582657,
    y1: 861.799583,
    x1: 1522.582657,
    fillOpacity: "null",
    strokeOpacity: "null",
    stroke: "#666666",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "svg_19",
    y2: 731.799583,
    x2: 1522.582657,
    y1: 862.799583,
    x1: 1230.582657,
    fillOpacity: "null",
    strokeOpacity: "null",
    stroke: "#666666",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    id: "svg_20",
    y2: 849.174988,
    x2: 1097.875,
    y1: 806.174988,
    x1: 1064.875,
    fillOpacity: "null",
    strokeOpacity: "null",
    stroke: "#666666",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScalePlate);
export default __webpack_public_path__ + "static/media/scale_plate.c2e46adf3c8fca688008ab76804fcad0.svg";
export { ForwardRef as ReactComponent };